// extracted by mini-css-extract-plugin
export default {"container":"CtaSection_container__iQ8do","headerTitle":"CtaSection_headerTitle__ERXX4","sectionText":"CtaSection_sectionText__G2G2D"};